import { render, staticRenderFns } from "./YA_AboutTitle.vue?vue&type=template&id=1d5f0c48&scoped=true"
import script from "./YA_AboutTitle.vue?vue&type=script&lang=js"
export * from "./YA_AboutTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f0c48",
  null
  
)

export default component.exports